export const firebaseConfig = {
  apiKey: 'AIzaSyBc6ccgRy4f8Etj2AUmS990qoQWLAZOTM0',
  authDomain: 'sai-labo-sample-new-media.firebaseapp.com',
  databaseURL: 'https://sai-labo-sample-new-media.firebaseio.com',
  projectId: 'sai-labo-sample-new-media',
  storageBucket: 'sai-labo-sample-new-media.appspot.com',
  messagingSenderId: '830684584510',
  appId: '1:830684584510:web:836404b891ff1c4d98cf6f',
  measurementId: 'G-66WFJ2JJ0C'
}